import { Pagination, Icon } from '@a-ui/react';
import { useSelector, useDispatch  } from 'react-redux'
import { useState, useEffect } from 'react';
import { setPage, setPageSize } from '../../store/slices/tasksReducer'


const TaskPagination = (prop) => {
  const [windowDimensions, setWindowDimensions] = useState(false)

  const hasWindow = typeof window !== 'undefined';

  useEffect(() => {
    if (hasWindow) {
      const getWindowDimensions = () => {
        const width = hasWindow ? window.innerWidth : null;
        const height = hasWindow ? window.innerHeight : null;
        return {
          width,
          height,
        };
      };
      setWindowDimensions(getWindowDimensions());
      const handleResize = () => {
        setWindowDimensions(getWindowDimensions());
      }
      window.addEventListener('resize', handleResize);
      return () => window.removeEventListener('resize', handleResize);
    }
  }, [hasWindow]);

  const { page, pageSize, totalValues } = useSelector(state => state.tasks)
  const dispatch = useDispatch()

  // Calculate the correct range for client-side pagination
  const startItem = totalValues > 0 ? ((page-1)*pageSize)+1 : 0;
  const endItem = Math.min((page-1)*pageSize+pageSize, totalValues);

  return <div className="paginationHolder u-margin-top u-margin-bottom row">

    <div className="col-xs-12 col-md-4 u-margin-bottom paginationHolder">
      <div className="a-input has-icon-right pagesize u-margin-right-xs">
        <div className="a-input__wrapper a-input__wrapper--inline">
          <select name="input-select" value={pageSize} id="input-select" onChange={e => dispatch(setPageSize(e.target.value)) }>
            <option value="1">1</option>
            <option value="5">5</option>
            <option value="10">10</option>
            <option value="30">30</option>
            <option value="50">50</option>
          </select>
          <Icon name="ai-arrow-down-1"/>
        </div>
      </div>
      <span>items per pagina | {totalValues > 0 ? `${startItem}-${endItem}` : '0'} van {totalValues} </span>
    </div>
    <div className="col-xs-12 col-md-8 pages">

      <Pagination
        currentPage={page}
        display={ windowDimensions.width > 720 ? "numbers" : "text" }
        itemsPerPage={pageSize}
        onChange={page => dispatch(setPage(page))}
        totalItems={totalValues}
      />
    </div>
  </div>
}

export default TaskPagination;
